export default __webpack_public_path__ + "static/phone-e34bcc30851bc3226ce2aa193b081cda.png";